export const colorCombinations = [
	{
		color: '#15AFD5'
	},
	{
		color: '#55D491'
	},
	{
		color: '#256CF0'
	},
	{
		color: '#AB47BC'
	},
	{
		color: '#FF9500'
	},
	{
		color: '#2196f3'
	},
	{
		color: '#43a047'
	},
	{
		color: '#3949ab'
	},
	{
		color: '#f44336'
	},
	{
		color: '#921c4a'
	},
	{
		color: '#435ef6'
	},
	{
		color: '#84cac3'
	},
	{
		color: '#d7a859'
	},
	{
		color: '#e14938'
	},
	{
		color: '#f6bd42'
	},
	{
		color: '#8ac54f'
	}
];
